import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarShirtStyle1 } from './Style1'
import { Style as AvatarShirtStyle2 } from './Style2'
import { Style as AvatarShirtStyle3 } from './Style3'
import { Style as AvatarShirtStyle4 } from './Style4'
import { Style as AvatarShirtStyle5 } from './Style5'

export const NAME = 'shirt'
export const STYLES = {
  style3: AvatarShirtStyle3,
  style2: AvatarShirtStyle2,
  style4: AvatarShirtStyle4,
  style1: AvatarShirtStyle1
  // style5: AvatarShirtStyle5
}
export const INLINE_STYLE = {
  width: '110%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-15%)'
}
export const AvatarShirt = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}
